export const TXTCLI_Month = {
  "id": "TXTCLI_Month",
  "defaultMessage": "Month"
} as const;

export const TXTCLI_Year = {
  "id": "TXTCLI_Year",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Year"
} as const;

export const TXTCLI_LoadingXX = {
  "id": "TXTCLI_LoadingXX",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Loading..."
} as const;

export const TXTCLI_Close = {
  "id": "TXTCLI_Close",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Close"
} as const;